module.exports = __webpack_public_path__ + "videos/brushes_jp.18deadc.mp4";